import {Box, Button, Container, Typography} from "@mui/material";
import {styled} from "@mui/system";

import WFEImage from "../resources/image/WFE-Logo.png"
import MicrosoftLogo from "../resources/image/Microsoft-Office365-White-Logo.png"
import Footer from "./common/Footer";

const LoginContainer = styled(Container)(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    minWidth: '100vw',
    backgroundColor: 'rgb(245, 247, 250)',
}));

const Card = styled(Box)(({theme}) => ({
    padding: theme.spacing(4),
    borderRadius: '2rem',
    boxShadow: '0px 4px 6px -1px rgba(0,0,0,0.05), 0px 2px 4px -1px rgba(0,0,0,0.03)',
    backgroundColor: '#ffffff',
    textAlign: 'center',
    maxWidth: 550,
    width: '100%',
}));

const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '2.75rem',
  marginTop: theme.spacing(4),
}));

const SubTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
}));

const SubscriptText = styled((props) => <Typography {...props} component="p" variant="subtitle2"/>)(({theme}) => ({
    marginTop: theme.spacing(6),
    marginBottom: '1rem',
    opacity: 0.4,
    fontSize: '1rem',
}));

export default function LoginPanel({onLoginClicked}) {
    return (
        <LoginContainer>
            <Card>
                <Box sx={{mb: 2, mt: 2}}><img src={WFEImage} alt="World Family" style={{width: '100px', height: 'auto'}}/></Box>
                <Title variant="h3">VE Back Office</Title>
                <SubTitle>Performer and Admin System</SubTitle>
                <SubscriptText>Log in with</SubscriptText>
                <Button
                    variant="contained"
                    color="primary"
                    sx={{backgroundColor: '#403CEF', fontSize: '0.875rem', mb: 2, textTransform: 'none'}}
                    onClick={onLoginClicked}>
                    <Box sx={{display: 'flex', alignItems: 'center'}}>
                        <img src={MicrosoftLogo} alt="Logo" style={{width: '1rem', marginRight: '0.5rem'}}/>
                        WFE Microsoft Account
                    </Box>
                </Button>
            </Card>
            <Footer/>
        </LoginContainer>
    );
}